import { createContext } from 'react';

export type BrandingSettingsCtx = {
  showSuccessAlert: boolean;
  showErrorAlert: boolean;
  error: string;
};

const BrandingSettingsContext = createContext<BrandingSettingsCtx>({
  showSuccessAlert: false,
  showErrorAlert: false,
  error: '',
});

export default BrandingSettingsContext;
